import React from "react";
import { Link } from "react-router-dom";

/**
 * Shared brand logo used across landing, navbar, dashboard sidebar, and auth screens.
 * Matches landing page treatment exactly:
 *  - Dark rounded tile with cream "TS" mark
 *  - Wordmark "TeachingSoftware.ai" with mango-yellow ".ai" accent
 *
 * Sizes:
 *   sm  → tile 24px, text 13px
 *   md  → tile 28px, text 15px (default)
 *   lg  → tile 32px, text 17px
 */
export function AppLogo({ size = "md", as = "link", to = "/", className = "", showWordmark = true, testid = "logo-link" }) {
  const sizes = {
    sm: { tile: "w-6 h-6", mark: "text-[10px]", word: "text-[13px]" },
    md: { tile: "w-7 h-7", mark: "text-[11px]", word: "text-[15px]" },
    lg: { tile: "w-8 h-8", mark: "text-[12px]", word: "text-[17px]" },
  };
  const s = sizes[size] || sizes.md;
  const content = (
    <>
      <div className={`${s.tile} rounded-md bg-[#0A0C10] flex items-center justify-center shrink-0`}>
        <span className={`text-[#FBFAF7] font-display font-bold ${s.mark}`}>TS</span>
      </div>
      {showWordmark && (
        <span className={`font-display font-semibold tracking-tight ${s.word}`}>
          TeachingSoftware<span className="text-[#FFB400]">.ai</span>
        </span>
      )}
    </>
  );
  if (as === "link") {
    return (
      <Link to={to} className={`flex items-center gap-2.5 ${className}`} data-testid={testid}>
        {content}
      </Link>
    );
  }
  return <div className={`flex items-center gap-2.5 ${className}`} data-testid={testid}>{content}</div>;
}
